import { ICardEntity, IStoryEntity } from '@/graphql/__generated__/global/types';

export const determineIfSiblingCardHasImage = (cards: ICardEntity[] | IStoryEntity[], cardIndex: number): boolean => {
    const isCardEven = cardIndex % 2 === 0;
    // If the card is even we want to check if the card to the right has an image.
    // Else check if the card to the left has an image.
    const sibling = isCardEven ? cards[cardIndex + 1] : cards[cardIndex - 1];

    if (sibling?.attributes) {
        if ('Card' in sibling.attributes) {
            return Boolean(sibling.attributes?.Card?.image?.data?.attributes?.url);
        } else if ('hero' in sibling.attributes) {
            return Boolean(sibling.attributes?.hero?.image?.image?.data?.attributes?.url);
        }
    }

    return false;
};
